var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fullscreen fixed bg-black-90 top-0 flex items-center flex-wrap z-9999 overflow-y-auto justify-center"},[_c('div',{staticClass:"absolute ma3 top-0 right-0 z-1"},[_c('v-icon',{on:{"click":_vm.onModalCloseRequested}},[_vm._v("mdi-close")])],1),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }